import { DilysuService } from "./craidd/gwasanaethau/defnyddiwr/dilysu.service";

// Llwytho reit ar cychwyn yr ap cyn popeth arall
export function initializeApp(dilysuService: DilysuService): () => Promise<void> {
  return async () => dilysuService.llwythoDefnyddiwr();
}